var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',[_c('dynamic-zone-renderer',{attrs:{"components":_vm.content.components}}),_vm._t("unlock-prompt"),_c('div',{staticClass:"px-4"},[_c('ProgressChecker',{attrs:{"type":"foundational","id":"0","has-prev":_vm.hasPrev,"has-next":_vm.hasNext},on:{"nextSection":function($event){return _vm.$emit('nextSection')}}})],1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }